<template>
  <section>
    <search :searchStatus="false"></search>
    <section class="padding-footer">
      <div class="util-list-header">
        <div>
          <img src="@/assets/img/util-tab-5-title.svg" />
        </div>
        <div class="util-list-header-title">
          <strong>Pencatatan Downtime</strong>
          <span>Downtime Notes History</span>
        </div>
      </div>
      <util-date :dates="dates" @apply="filter"></util-date>
      <b-container>
        <util-item-downtime @select="onItemSelect"  :listdata="list"></util-item-downtime>
        <div v-show="page < data?.last_page" @click="loadMore" class="load-more">Load More</div>

      </b-container>

    </section>
    <!-- <MenuFooter /> -->
    <util-add action="/downtime/add" v-if="group == 'Operator Maintenance' || group == 'Operator Project'"></util-add>
    
    <div class="item-action" :class="action !== null ? '' : 'hides'">
      <div class="backdrop" @click="action = null"></div>
      <div class="bottom-panel">
        <img
          src="@/assets/img/filter-close.svg"
          alt=""
          class="close"
          @click="action = null"
        />
        <div class="action" @click="goto('view')" v-show="status == 'close' || group == 'Supervisor'">
          <img src="@/assets/img/task-view.svg" alt="" />
          <span>Lihat Detail</span>
        </div>
        <div class="action" @click="goto('task')" v-show="status != 'close' && group != 'Supervisor'">
          <img src="@/assets/img/task.svg" alt="" />
          <span>Kerjakan</span>
        </div>
      </div>
    </div>

  </section>
</template>
<script lang="js">
import dayjs from "dayjs";

import Vue from "vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import UtilItemDowntime from "@/views/pages/Utilities/Components/Util-Item-Downtime.vue";
import UtilAdd from "@/views/pages/Utilities/Components/Util-Add.vue";
import UtilDate from "@/views/pages/Utilities/Components/Util-Date.vue";
import { api } from "@/api/api.js";
import { UserModule } from "@/store/modules/user";

@Component({
    components: {
        MenuFooter,
        Search,
        UtilItemDowntime,
        UtilAdd,
        UtilDate,
    },
})
export default class UtilitiesListDowntime extends Vue {
  status = null
  action = null
    onItemSelect(item) {
      this.action = item.id
      this.status = item.status
    }
   
    goto(type){
      this.$router.push({ path: "/downtime/"+type+"/"+this.action })
      this.action = null
    }
    dayjs = dayjs
  dates = {start:dayjs().subtract(7, "days").format("YYYY-MM-DD"),end:dayjs().format("YYYY-MM-DD")}
  list = [];
  filter(e){
    this.dates = e
    this.search()
  }
  search(){
    api('downtime_list',{params:{date_start: this.dates.start, date_end: this.dates.end}}).then(res => {
      this.list = res.data.data.map(e=>{
        e.date = new Date(e.usage_date);
        return e
      })
      this.data = res.data
    })

  }
  data = null
  page = 1
  loadMore(){
    api('downtime_list',{params:{date_start: this.dates.start, date_end: this.dates.end, page: this.page+1}}).then(res => {
      this.list = this.list.concat(res.data.data).map(e=>{
        
        e.date = new Date(e.usage_date);
        return e
      })
      this.data = res.data
    })
  }
  mounted(){
    this.search()
  }
  group = UserModule.userDetail.accessgroup['name'];
}
</script>
